import React, { useState, createContext } from 'react';
import useQueryString from "../hooks/useQueryString";

export const GeoContext = createContext();

export const GeoProvider = ({ children }) => {
    const [selections, setSelections] = useState(["CROP Countries"]);
    
    const [selectedGeometry, setSelectedGeometry] = useQueryString(
        "selectedGeometry",
        "CROP Countries"
    );

    return (
        <GeoContext.Provider value={{selections, setSelections, selectedGeometry, setSelectedGeometry}}>
            {children}
        </GeoContext.Provider>
    )
};